
const config = {
    drawerWidth: 280,
    TITLE: 'Fermi2',
    VERSAO: '2.0.37',
    BASE_URLd : 'http://107.23.88.193/api',
    BASE_URLl : 'http://localhost:3200/api',
    BASE_URL : 'https://api-fermi.cientificoeducacao.com.br/api',
    BUCKET_NAME : 'fermi-images.cientificoeducacao.com.br',
    BUCKET_URL : "https://api-fermi.cientificoeducacao.com.br/api/PersonPics/fermi-images.cientificoeducacao.com.br/download",
    MINIO_BUCKET : 'fermi-docs'
}

export default config;
